<template>
  <path
    d="M1.20508 3.48136L2.66048 4.93676L5.93512 1.66211"
    stroke="white"
    stroke-width="1.4554"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
